import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-i-conditions-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IConditionsListPanel = _resolveComponent("IConditionsListPanel")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.conditionsList, (conditionsDetail, key) => {
      return (_openBlock(), _createElementBlock("li", {
        class: "p-i-conditions-list__item",
        key: key
      }, [
        _createVNode(_component_IConditionsListPanel, { "conditions-detail": conditionsDetail }, null, 8, ["conditions-detail"])
      ]))
    }), 128))
  ]))
}